import { Alert } from '@mui/material'
import React, { useCallback } from 'react'

import { ProvenanceTargetType } from 'components/attacks/create/create-attack-types'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import { ServiceCreationReadiness } from 'types/api/services/service-creation-readiness'

export const ServiceTypeCollectionMessage: React.FC<{
  serviceCreationReadiness: ServiceCreationReadiness
  targetType: ProvenanceTargetType
}> = ({ serviceCreationReadiness, targetType }) => {
  const getMessage = useCallback(() => {
    // case where process collection is not turned on yet
    if (
      !serviceCreationReadiness?.processCollectionOn &&
      !serviceCreationReadiness?.hasProcesses
    ) {
      return (
        <>
          <TrackedExternalLink href="https://www.gremlin.com/docs/getting-started/enabling-process-collection">
            Process collection
          </TrackedExternalLink>{' '}
          must be enabled for {targetType} before continuing.{' '}
          {targetType === ProvenanceTargetType.ProcessData && (
            <p data-test-p-host-service="host-minimum">
              <b>NOTE</b>: Host services need at least two agents to discover
              new processes
            </p>
          )}
        </>
      )
      // Process collection is on but has not finished running or there were no processes found.
    } else if (
      serviceCreationReadiness?.processCollectionOn &&
      !serviceCreationReadiness?.hasProcesses
    ) {
      return (
        <>
          Gremlin is not seeing any running processes where agents have been
          installed yet. If you installed a new agent in the past 10 minutes,
          come back in a couple of minutes. Otherwise, make sure you have
          running processes where you installed your Gremlin agents.
        </>
      )
    }
    return null
  }, [serviceCreationReadiness, targetType])

  const collectionMessage = getMessage()
  return (
    <>
      {collectionMessage && (
        <Alert data-test-process-exists-alert severity="warning">
          {collectionMessage}
        </Alert>
      )}
    </>
  )
}
